export default "__VITE_ASSET__BTG2tBwI__"